var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 80.032H360C373.25 80.032 384 69.275 384 56.016S373.25 32 360 32H24C10.75 32 0 42.757 0 56.016S10.75 80.032 24 80.032ZM81.469 304.173L168 212.12V455.964C168 469.234 178.75 480 192 480S216 469.234 216 455.964V212.12L302.531 304.173C307.25 309.212 313.625 311.747 320 311.747C325.906 311.747 331.812 309.587 336.438 305.206C346.094 296.129 346.562 280.919 337.469 271.248L209.469 135.043C200.406 125.341 183.594 125.341 174.531 135.043L46.531 271.248C37.438 280.919 37.906 296.129 47.563 305.206C57.188 314.313 72.375 313.875 81.469 304.173Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpToLine);
export default __webpack_public_path__ + "static/media/arrow-up-to-line.3dddb1d594b3b32fd7b8b9167ac345de.svg";
export { ForwardRef as ReactComponent };